import { closeSideBar } from '@/store/modules/selectedNode/actions';
import { useStore } from '@/utils/store';

export const useSelectedNodeActions = () => {
	const { dispatch } = useStore();
	return {
		closeSideBar: (payload?: { avoidRedirect: boolean }) => dispatch<undefined | { avoidRedirect: boolean }, void>(closeSideBar, payload),
	};
};
